import { FeedbackForm, FeedbackResponse, SubmitFeedbackDTO } from '../types/feedback/feedback-form';
import { endpoints, axiosInstance } from '../utils/axios';

export async function findFeedbackResponseBySlug(slug: string): Promise<FeedbackResponse> {
  const url = endpoints.feedback.getResponse(slug);
  const response = await axiosInstance.get<FeedbackResponse>(url);
  return response.data;
}

export async function submitFeedback(payload: SubmitFeedbackDTO) {
  const url = endpoints.feedback.submit(payload.slug);
  await axiosInstance.put(url, { answers: payload.answers, userId: payload.userId });
}

export async function submitFeedbackWithoutSlug(eventId: number, payload: SubmitFeedbackDTO) {
  if (!payload.formId) return;
  const url = endpoints.feedback.submitWithoutSlug(eventId, payload.formId);
  await axiosInstance.post(url, { answers: payload.answers, userId: payload.userId });
}

export async function findFeedbackFormByEventId(eventId: number): Promise<FeedbackForm> {
  const url = endpoints.feedback.getForm(eventId);
  const response = await axiosInstance.get<FeedbackForm>(url);
  return response.data;
}
